import { render, staticRenderFns } from "./PostalAddressValidator.vue?vue&type=template&id=26de28f7&scoped=true&"
import script from "./PostalAddressValidator.vue?vue&type=script&lang=js&"
export * from "./PostalAddressValidator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26de28f7",
  null
  
)

export default component.exports